export default {
  available: 'Dostępne',
  selected: 'Wybrane',
  noItemsSelected: 'Nie wybrano żadnego elementu',
  confirm: 'Czy na pewno chcesz to zrobić?',
  fields: {
    action: 'Akcja',
    name: 'Nazwa',
    added: 'Dodano',
  },
  status: {
    title: 'Status',
    added: 'Dodane',
    noAdded: 'Nie dodane',
  },
  search: 'Szukaj',
  noMatchingResults: 'Nie znaleziono pasujących rekordów',
  noDataAvailable: 'Brak danych',
  rowsPerPageText: 'Rekordów na stronę:',
  records: 'Rekordy',
  from: 'z',
  add: 'Dodaj',
  all: 'Wszystko',
  buttons: {
    remove: 'Usuń',
    add: 'Dodaj',
    removeMany: 'Usuń wiele',
    addMany: 'Dodaj wiele',
    close: 'Zamknij',
  },
}
